import { useMemo } from "react";
import useResources from "./use-resources";
import useProfileFilter from "./use-profile-filter";

const ROOT_PATH = "banks";

export default function useBanks() {
  const {
    resources: allBanks,
    error,
    isLoading,
    create,
    update,
    del,
    mutate,
  } = useResources(ROOT_PATH);
  const { matchesProfileFilter, isFilterActive } = useProfileFilter();

  const banks = useMemo(() => {
    if (!isFilterActive) return allBanks;
    return allBanks.filter(
      (bank) =>
        bank.id_profile_nom == null ||
        matchesProfileFilter(bank.id_profile_nom),
    );
  }, [allBanks, isFilterActive, matchesProfileFilter]);

  return {
    banks,
    error,
    isLoading,
    addBank: create,
    updateBank: update,
    deleteBank: del,
    refreshBanks: mutate,
  };
}
